import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class VersaoService {

    private baseUrl = environment.APIEndpoint;

    constructor(private http: HttpClient) {}

    obterVersao(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/calculadora/dados-abertos/versao`);
    }

    obterStatusVersaoOffline(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/versao/status`);
    }
}
